// Tipos centralizados para Lead e entidades relacionadas

// === STATUS DO LEAD (fonte da verdade) ===
export const LEAD_STATUS = [
  'partial',
  'novo',
  'contatado',
  'em_atendimento',
  'orcamento',
  'sem_retorno',
  'convertido',
  'perdido',
  // Legacy (backward compat com dados existentes)
  'tentativa_1',
  'tentativa_2',
  'tentativa_3',
  'qualificado',
  'agendado',
] as const

export type LeadStatus = (typeof LEAD_STATUS)[number]

// Mapeamento de status legados para os novos
export const LEGACY_STATUS_MAP: Record<string, string> = {
  tentativa_1: 'contatado',
  tentativa_2: 'contatado',
  tentativa_3: 'contatado',
  qualificado: 'em_atendimento',
  agendado: 'orcamento',
}

// Resolve status legado para o novo equivalente
export const resolveStatus = (status?: string): string => {
  if (!status) return 'novo'
  return LEGACY_STATUS_MAP[status] || status
}

// Status que indicam leads ativos (não finalizados)
export const LEAD_STATUS_ATIVOS: LeadStatus[] = [
  'partial',
  'novo',
  'contatado',
  'em_atendimento',
  'orcamento',
  'sem_retorno',
  // Legacy
  'tentativa_1',
  'tentativa_2',
  'tentativa_3',
  'qualificado',
  'agendado',
]

// Status que indicam leads finalizados
export const LEAD_STATUS_FINALIZADOS: LeadStatus[] = ['convertido', 'perdido']

// === CONFIG DE STATUS (labels, cores, ícones) ===
export const STATUS_CONFIG: Record<LeadStatus, {
  label: string
  color: string
  bgColor: string
  textColor: string
  badgeColor: string
  headerColor: string
  accentColor: string
  step: number
}> = {
  partial: {
    label: 'Lead parcial',
    color: 'orange',
    bgColor: 'bg-orange-500/5',
    textColor: 'text-orange-400',
    badgeColor: 'bg-orange-500/20 border-orange-500/30',
    headerColor: 'bg-orange-500/10',
    accentColor: 'bg-orange-500',
    step: 0,
  },
  novo: {
    label: 'Lead novo',
    color: 'blue',
    bgColor: 'bg-blue-500/5',
    textColor: 'text-blue-400',
    badgeColor: 'bg-blue-500/20 border-blue-500/30',
    headerColor: 'bg-blue-500/10',
    accentColor: 'bg-blue-500',
    step: 1,
  },
  contatado: {
    label: 'Tentativa de contato',
    color: 'cyan',
    bgColor: 'bg-cyan-500/5',
    textColor: 'text-cyan-400',
    badgeColor: 'bg-cyan-500/20 border-cyan-500/30',
    headerColor: 'bg-cyan-500/10',
    accentColor: 'bg-cyan-500',
    step: 2,
  },
  em_atendimento: {
    label: 'Em atendimento',
    color: 'amber',
    bgColor: 'bg-amber-500/5',
    textColor: 'text-amber-400',
    badgeColor: 'bg-amber-500/20 border-amber-500/30',
    headerColor: 'bg-amber-500/10',
    accentColor: 'bg-amber-500',
    step: 3,
  },
  orcamento: {
    label: 'Orçamento',
    color: 'violet',
    bgColor: 'bg-violet-500/5',
    textColor: 'text-violet-400',
    badgeColor: 'bg-violet-500/20 border-violet-500/30',
    headerColor: 'bg-violet-500/10',
    accentColor: 'bg-violet-500',
    step: 4,
  },
  sem_retorno: {
    label: 'Sem retorno',
    color: 'rose',
    bgColor: 'bg-rose-500/5',
    textColor: 'text-rose-400',
    badgeColor: 'bg-rose-500/20 border-rose-500/30',
    headerColor: 'bg-rose-500/10',
    accentColor: 'bg-rose-500',
    step: 5,
  },
  convertido: {
    label: 'Venda fechada',
    color: 'green',
    bgColor: 'bg-green-500/5',
    textColor: 'text-green-400',
    badgeColor: 'bg-green-500/20 border-green-500/30',
    headerColor: 'bg-green-500/10',
    accentColor: 'bg-green-500',
    step: 6,
  },
  perdido: {
    label: 'Não fechado',
    color: 'zinc',
    bgColor: 'bg-zinc-500/5',
    textColor: 'text-zinc-400',
    badgeColor: 'bg-zinc-500/20 border-zinc-500/30',
    headerColor: 'bg-zinc-500/10',
    accentColor: 'bg-zinc-500',
    step: 7,
  },
  // Legacy statuses (backward compat)
  tentativa_1: {
    label: 'Tentativa de contato',
    color: 'cyan',
    bgColor: 'bg-cyan-500/5',
    textColor: 'text-cyan-400',
    badgeColor: 'bg-cyan-500/20 border-cyan-500/30',
    headerColor: 'bg-cyan-500/10',
    accentColor: 'bg-cyan-500',
    step: 2,
  },
  tentativa_2: {
    label: 'Tentativa de contato',
    color: 'cyan',
    bgColor: 'bg-cyan-500/5',
    textColor: 'text-cyan-400',
    badgeColor: 'bg-cyan-500/20 border-cyan-500/30',
    headerColor: 'bg-cyan-500/10',
    accentColor: 'bg-cyan-500',
    step: 2,
  },
  tentativa_3: {
    label: 'Tentativa de contato',
    color: 'cyan',
    bgColor: 'bg-cyan-500/5',
    textColor: 'text-cyan-400',
    badgeColor: 'bg-cyan-500/20 border-cyan-500/30',
    headerColor: 'bg-cyan-500/10',
    accentColor: 'bg-cyan-500',
    step: 2,
  },
  qualificado: {
    label: 'Em atendimento',
    color: 'amber',
    bgColor: 'bg-amber-500/5',
    textColor: 'text-amber-400',
    badgeColor: 'bg-amber-500/20 border-amber-500/30',
    headerColor: 'bg-amber-500/10',
    accentColor: 'bg-amber-500',
    step: 3,
  },
  agendado: {
    label: 'Orçamento',
    color: 'violet',
    bgColor: 'bg-violet-500/5',
    textColor: 'text-violet-400',
    badgeColor: 'bg-violet-500/20 border-violet-500/30',
    headerColor: 'bg-violet-500/10',
    accentColor: 'bg-violet-500',
    step: 4,
  },
}

// === TIPOS DO PROJETO ===
export type ProjectType = 'simples' | 'institucional' | 'personalizado'

export const PROJECT_TYPE_CONFIG: Record<ProjectType, { label: string; color: string; value: number }> = {
  simples: { label: 'Presença Digital', color: 'bg-emerald-500/20 text-emerald-400', value: 997 },
  institucional: { label: 'Institucional', color: 'bg-purple-500/20 text-purple-400', value: 2497 },
  personalizado: { label: 'Personalizado', color: 'bg-orange-500/20 text-orange-400', value: 5000 },
}

// === TIPOS DE URGÊNCIA ===
export type UrgencyType = '7_days' | '15_30_days' | 'negotiate'

export const URGENCY_CONFIG: Record<UrgencyType, { label: string; priority: number; color: string }> = {
  '7_days': { label: '7 dias', priority: 3, color: 'text-red-400' },
  '15_30_days': { label: '15-30 dias', priority: 2, color: 'text-yellow-400' },
  negotiate: { label: 'A negociar', priority: 1, color: 'text-zinc-400' },
}

// === TIPOS DE TEMPERATURA ===
export type LeadTemperature = 'hot' | 'warm' | 'cold'

// === ETAPA DE NEGOCIAÇÃO ===
export type EtapaNegociacao =
  | 'primeiro_contato'
  | 'interesse_confirmado'
  | 'proposta_enviada'
  | 'negociando'
  | 'decisao_pendente'

export const ETAPA_NEGOCIACAO_CONFIG: Record<EtapaNegociacao, {
  label: string
  cor: string
  ordem: number
}> = {
  primeiro_contato: { label: 'Primeiro contato', cor: 'cyan', ordem: 0 },
  interesse_confirmado: { label: 'Interesse confirmado', cor: 'blue', ordem: 1 },
  proposta_enviada: { label: 'Proposta enviada', cor: 'violet', ordem: 2 },
  negociando: { label: 'Negociando', cor: 'amber', ordem: 3 },
  decisao_pendente: { label: 'Decisão pendente', cor: 'orange', ordem: 4 },
}

// === OUTROS ENUMS ===
export type DemandType = 'pf' | 'pj'
export type SiteSituation = 'no_site' | 'has_site' | 'rebuild_site'
export type ProjectObjective = 'leads' | 'sales' | 'portfolio' | 'branding' | 'info'
export type ContentStatus = 'ready' | 'partial' | 'need_help'

// === LABELS CENTRALIZADOS ===
export const LABELS: Record<string, Record<string, string>> = {
  situation: { no_site: 'Primeiro site', has_site: 'Já tem site', rebuild_site: 'Quer refazer' },
  objective: { leads: 'Gerar leads', sales: 'Vender online', portfolio: 'Portfólio', branding: 'Fortalecer marca', info: 'Informar serviços' },
  urgency: { '7_days': '7 dias', '15_30_days': '15-30 dias', negotiate: 'A negociar' },
  projectType: { simples: 'Presença Digital', institucional: 'Institucional', personalizado: 'Personalizado' },
  contentStatus: { ready: 'Pronto', partial: 'Parcial', need_help: 'Precisa de ajuda' },
  demandType: { pf: 'Pessoa Física', pj: 'Empresa' },
}

export const getLabel = (categoria: string, valor?: string | null): string => {
  if (!valor) return '-'
  return LABELS[categoria]?.[valor] || valor
}

// === ANALYTICS DO LEAD ===
export interface LeadAnalytics {
  utm?: {
    source?: string | null
    medium?: string | null
    campaign?: string | null
    content?: string | null
    term?: string | null
    gclid?: string | null
  }
  device?: {
    type?: 'mobile' | 'desktop' | 'tablet'
    browser?: string
    browserVersion?: string
    os?: string
    osVersion?: string
    screen?: { width: number; height: number }
    viewport?: { width: number; height: number }
    touchEnabled?: boolean
  }
  geo?: {
    ip?: string
    country?: string
    region?: string | null
    city?: string | null
    timezone?: string
  }
  session?: {
    id?: string
    startTime?: string
    timeOnPage?: number
    formCompletionTime?: number
  }
  preferences?: {
    language?: string
    colorScheme?: 'light' | 'dark'
    abTheme?: string
    [key: string]: unknown
  }
  referrer?: {
    url?: string
    landingPage?: string
    entryPath?: string
  }
}

// === ENTRADA DE CONTATO ===
export type ContactType = 'call' | 'whatsapp' | 'email' | 'note' | 'status_change'

export interface ContactEntry {
  id?: string
  date: string
  type: ContactType
  description: string
  metadata?: Record<string, string>
}

// === INTERFACE LEAD PRINCIPAL ===
export interface Lead {
  id: string

  // Contato (obrigatório)
  nome: string
  email: string
  whatsapp?: string
  whatsappFormatted?: string

  // Perfil
  empresa?: string
  demandType?: DemandType | string | null

  // Situação atual
  situation?: SiteSituation | string | null
  currentSiteUrl?: string | null

  // Projeto
  objective?: ProjectObjective | string | null
  features?: string[]
  projectType?: ProjectType | string | null

  // Branding
  hasLogo?: boolean | null
  brandColors?: string[]
  referenceSites?: string[]

  // Conteúdo e prazo
  contentStatus?: ContentStatus | string | null
  urgency?: UrgencyType | string | null

  // Observações
  additional?: string | null

  // LGPD
  lgpdConsent?: boolean

  // Metadata
  source?: string
  createdAt?: string
  updatedAt?: string
  status?: LeadStatus | string
  quizVersion?: string
  isPartial?: boolean

  // A/B Testing
  abTheme?: 'light' | 'dark' | null

  // Tracking
  userAgent?: string | null
  ip?: string | null
  gclid?: string | null
  visitor_id?: string | null

  // Analytics
  analytics?: LeadAnalytics | null

  // Campos adicionados pelo admin (via PATCH)
  temperature?: LeadTemperature
  estimatedValue?: number
  notes?: string
  contactAttempts?: number
  lastContactAt?: string
  nextFollowUp?: string
  followUpType?: FollowUpType
  followUpNote?: string
  lostReason?: string
  qualifiedAt?: string
  convertedAt?: string
  contactHistory?: ContactEntry[]
  lastSyncAt?: string
  syncedMessageCount?: number
  tags?: string[]
  etapaNegociacao?: EtapaNegociacao

  // IA (preenchidos pelo cron/webhook de análise)
  aiScore?: number
  aiRiscoPerda?: 'baixo' | 'medio' | 'alto'
  aiAnalyzedAt?: string

  // WhatsApp (preenchidos automaticamente pelo webhook/envio)
  lastWhatsAppSent?: string
  lastWhatsAppMessage?: string
  lastResponseAt?: string
  lastResponseMessage?: string
  responseCount?: number
}

// === RESUMO IA (conversation_notes com type='ai_summary') ===
export interface AISummary {
  resumo: string
  proximaAcao: string
  sentimento: 'positivo' | 'neutro' | 'negativo' | 'urgente'
  riscoPerda: 'baixo' | 'medio' | 'alto'
  score: number
  insights: string[]
  sugestoesResposta: string[]
  analyzedAt: string
}

// === TIPOS DE ATIVIDADE ===
export const ACTIVITY_TYPES = [
  'lead_created',
  'lead_contacted',
  'lead_converted',
  'lead_lost',
  'lead_discarded',
  'whatsapp_sent',
  'whatsapp_received',
  'whatsapp_scheduled',
  'call_made',
  'email_sent',
  'note_added',
  'note_deleted',
  'status_changed',
  'temperature_changed',
  'tag_added',
  'tag_removed',
  'moved_to_stage',
  'followup_scheduled',
  'followup_completed',
  'message_scheduled',
  'archived',
  'unarchived',
  'ai_analysis',
] as const

export type ActivityType = (typeof ACTIVITY_TYPES)[number]

export interface ActivityItem {
  id: string
  type: ActivityType
  leadId?: string
  leadName?: string
  description: string
  metadata?: Record<string, unknown>
  userId?: string
  userName?: string
  createdAt: string
  isNew?: boolean
}

// === FOLLOW-UP ===
export type FollowUpType = 'call' | 'whatsapp' | 'email' | 'meeting'

export interface FollowUp {
  id: string
  leadId: string
  leadName: string
  date: string
  time?: string
  type: FollowUpType
  note?: string
  completed?: boolean
}

// === SDR METRICS ===
export interface SDRMetrics {
  contactsToday: number
  contactsGoal: number
  conversionsToday: number
  conversionsWeek: number
  conversionRate: number
  avgResponseTime: number
  streak: number
  totalPoints: number
  level: number
  activitiesCount: number
}
